// 我的档案相关
const studyBook = () => import('@/pages/studyBook/index.vue');
const studyBookExperience = () => import('@/pages/studyBook/experienceProduct.vue');

export default [
  {
    path: '/studyBook',
    component: studyBook,
  },
  {
    path: '/studyBookExperience',
    component: studyBookExperience,
  },
];

